// Reusable context menu styling utilities

export const getDeleteContextMenuItem = (
  title: string,
  onClickHandler: (contextId: string) => void,
  requiresConfirmation: boolean = true,
  confirmationConfig?: {
    title?: string;
    message?: string;
    severity?: "danger" | "warning";
    icon?: string;
  }
) => ({
  title,
  onClickHandler,
  icon: "/img/trash-red.svg",
  style: {
    backgroundColor: "#F0DFDE",
    color: "red",
  },
  requiresConfirmation,
  confirmationConfig: {
    title: confirmationConfig?.title || "Confirm Delete",
    message: confirmationConfig?.message || `Are you sure you want to ${title.toLowerCase()}? This action cannot be undone.`,
    severity: confirmationConfig?.severity || "danger",
    icon: confirmationConfig?.icon || "/img/trash-red.svg"
  }
});
